webpackJsonp([1,5],{

/***/ "5Wae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_tracking_module__ = __webpack_require__("k/7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_index__ = __webpack_require__("9db2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_module__ = __webpack_require__("OTuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ngx_cookie_src_cookie_options_provider__ = __webpack_require__("8xgx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tracking_component_ngfactory__ = __webpack_require__("9gmB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_auth_auth_service__ = __webpack_require__("TZHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TrackingModuleNgFactory", function() { return TrackingModuleNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();










var TrackingModuleInjector = (function (_super) {
    __extends(TrackingModuleInjector, _super);
    function TrackingModuleInjector(parent) {
        return _super.call(this, parent, [__WEBPACK_IMPORTED_MODULE_7__tracking_component_ngfactory__["a" /* TrackingComponentNgFactory */]], []) || this;
    }
    Object.defineProperty(TrackingModuleInjector.prototype, "_BrowserXhr_4", {
        get: function () {
            if ((this.__BrowserXhr_4 == null)) {
                (this.__BrowserXhr_4 = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["a" /* BrowserXhr */]());
            }
            return this.__BrowserXhr_4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackingModuleInjector.prototype, "_ResponseOptions_5", {
        get: function () {
            if ((this.__ResponseOptions_5 == null)) {
                (this.__ResponseOptions_5 = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* BaseResponseOptions */]());
            }
            return this.__ResponseOptions_5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackingModuleInjector.prototype, "_XSRFStrategy_6", {
        get: function () {
            if ((this.__XSRFStrategy_6 == null)) {
                (this.__XSRFStrategy_6 = new __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_tracking_module__["a" /* NoXSRFStrategy */]());
            }
            return this.__XSRFStrategy_6;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackingModuleInjector.prototype, "_XHRBackend_7", {
        get: function () {
            if ((this.__XHRBackend_7 == null)) {
                (this.__XHRBackend_7 = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* XHRBackend */](this._BrowserXhr_4, this._ResponseOptions_5, this._XSRFStrategy_6));
            }
            return this.__XHRBackend_7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackingModuleInjector.prototype, "_RequestOptions_8", {
        get: function () {
            if ((this.__RequestOptions_8 == null)) {
                (this.__RequestOptions_8 = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["d" /* BaseRequestOptions */]());
            }
            return this.__RequestOptions_8;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackingModuleInjector.prototype, "_Http_9", {
        get: function () {
            if ((this.__Http_9 == null)) {
                (this.__Http_9 = __WEBPACK_IMPORTED_MODULE_2__angular_http__["e" /* ɵc */](this._XHRBackend_7, this._RequestOptions_8));
            }
            return this.__Http_9;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackingModuleInjector.prototype, "_CookieOptionsProvider_10", {
        get: function () {
            if ((this.__CookieOptionsProvider_10 == null)) {
                (this.__CookieOptionsProvider_10 = new __WEBPACK_IMPORTED_MODULE_5_ngx_cookie_src_cookie_options_provider__["a" /* CookieOptionsProvider */](this.parent.get(__WEBPACK_IMPORTED_MODULE_5_ngx_cookie_src_cookie_options_provider__["b" /* COOKIE_OPTIONS */]), this));
            }
            return this.__CookieOptionsProvider_10;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrackingModuleInjector.prototype, "_ErrorTracking_11", {
        get: function () {
            if ((this.__ErrorTracking_11 == null)) {
                (this.__ErrorTracking_11 = new __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */](this.parent.get(__WEBPACK_IMPORTED_MODULE_8__app_shared_auth_auth_service__["a" /* Auth */]), this.parent.get(__WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */])));
            }
            return this.__ErrorTracking_11;
        },
        enumerable: true,
        configurable: true
    });
    TrackingModuleInjector.prototype.createInternal = function () {
        this._HttpModule_0 = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["f" /* HttpModule */]();
        this._CookieModule_1 = new __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_index__["a" /* CookieModule */]();
        this._AuthModule_2 = new __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_module__["a" /* AuthModule */]();
        this._TrackingModule_3 = new __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_tracking_module__["b" /* TrackingModule */]();
        return this._TrackingModule_3;
    };
    TrackingModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_http__["f" /* HttpModule */])) {
            return this._HttpModule_0;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_index__["a" /* CookieModule */])) {
            return this._CookieModule_1;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_module__["a" /* AuthModule */])) {
            return this._AuthModule_2;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_tracking_module__["b" /* TrackingModule */])) {
            return this._TrackingModule_3;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_http__["a" /* BrowserXhr */])) {
            return this._BrowserXhr_4;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_http__["g" /* ResponseOptions */])) {
            return this._ResponseOptions_5;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_http__["h" /* XSRFStrategy */])) {
            return this._XSRFStrategy_6;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* XHRBackend */])) {
            return this._XHRBackend_7;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_http__["i" /* RequestOptions */])) {
            return this._RequestOptions_8;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_http__["j" /* Http */])) {
            return this._Http_9;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_5_ngx_cookie_src_cookie_options_provider__["a" /* CookieOptionsProvider */])) {
            return this._CookieOptionsProvider_10;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */])) {
            return this._ErrorTracking_11;
        }
        return notFoundResult;
    };
    TrackingModuleInjector.prototype.destroyInternal = function () {
    };
    return TrackingModuleInjector;
}(__WEBPACK_IMPORTED_MODULE_0__angular_core__["A" /* ɵNgModuleInjector */]));
var TrackingModuleNgFactory = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["B" /* NgModuleFactory */](TrackingModuleInjector, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_tracking_module__["b" /* TrackingModule */]);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9
//# sourceMappingURL=tracking.module.ngfactory.js.map

/***/ })

});


// WEBPACK FOOTER //
// 1.746252f637fa26ccd956.chunk.js